import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import BirthingPostpartumFlowsheetNotice from "@/encounters/components/EncounterLabor/EncounterLabor/LaborFlowsheetComponents/BirthingPostpartumFlowsheetNotice";
import { selectBirthDateTime, selectIsOptimisticBirth } from "@/store/slices/birth";

interface BirthingPostpartumFlowsheetNoticeFieldProps {
  /** Body-delivery form value: an ISO string (legacy generic form) or a Date (native Birthing form). */
  bodyDeliveredAt?: unknown;
}

/** Renders inline on the Birthing questionnaire when body delivery time is not set (including optimistic Redux birth time). */
export default function BirthingPostpartumFlowsheetNoticeField({
  bodyDeliveredAt,
}: BirthingPostpartumFlowsheetNoticeFieldProps) {
  const birthDateTime = useSelector(selectBirthDateTime);
  const isOptimisticBirth = useSelector(selectIsOptimisticBirth);
  const hasBodyDeliveryValue =
    bodyDeliveredAt instanceof Date ||
    (typeof bodyDeliveredAt === "string" && bodyDeliveredAt.trim().length > 0);

  // Ignore Redux birth time for this alert while it is only optimistic client state with an
  // empty Body Delivered field (stale optimistic after clear is handled in the drawer + slice).
  const hasBodyDeliveryRecorded =
    hasBodyDeliveryValue || (Boolean(birthDateTime?.trim()) && !isOptimisticBirth);

  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (hasBodyDeliveryRecorded) setDismissed(false);
  }, [hasBodyDeliveryRecorded]);

  if (hasBodyDeliveryRecorded || dismissed) return null;

  return <BirthingPostpartumFlowsheetNotice onDismiss={() => setDismissed(true)} />;
}
